export default class ContentTypeFieldInternalTableFilter {
    constructor (dto) {
        this.filterColumn = ''
        this.filterValue = ''

        if (dto) {
            this.filterColumn = dto.FilterColumn
            this.filterValue = dto.FilterValue
        }
    }
}
